exports.toSlug = (text) => {
  text = text.toLowerCase().replace(/'/g,'');
  text = text.replace(/\W/g,'-');
  text = text.replace(/---/g,'-');
  text = text.replace(/--/g,'-');
  text = text.replace(/-$/g,'');
  text = text.replace(/^-/g,'');
  return text;
}
exports.arrayToURL = (urls) => {
  return urls.join('/');
}


exports.universityCourseUrl = (cslug, uslug) => {
  return "/" + uslug + "/" + cslug;
}

exports.printUrl = (url) => {
  return "[URL] " + url;
}

exports.toMonth = (x) => {
  if(x === "1") return "Jan";
  if(x === "2") return "Feb";
  if(x === "3") return "Mar";
  if(x === "4") return "Apr";
  if(x === "5") return "May";
  if(x === "6") return "Jun";
  if(x === "7") return "Jul";
  if(x === "8") return "Aug";
  if(x === "9") return "Sep";
  if(x === "10") return "Oct";
  if(x === "11") return "Nov";
  if(x === "12") return "Dec";

}

const slash = (link) => {
  if(! link.startsWith('/')) {
    link = '/' + link;
  }

  if(! link.endsWith('/')) {
    link = link + '/';
  }
  return link
}
exports.slash = slash;

exports.uniThumbnailPath = (title) => {
  title = title.toLowerCase().replace(/ /g, '-');
  return `/icons/${title}.jpg`;
}

exports.thumbnailPath = (title) => {
  title = title.toLowerCase().replace(/ /g, '-');
  return `/covers/course-overview/thumbnail/${title}.jpg`;
}

exports.bannerPath = (title) => {
  title = title.toLowerCase().replace(/ /g, '-');
  return `/covers/course-overview/article/${title}.jpg`;
}

exports.coverPath = (title) => {
  eturn `/covers/course-overview/${title}.jpg`;
}

exports.leadXML = (name, email, phone, title) => {
  return `<Leads><row no="1">` +
    `<FL val="Title">${title}</FL>` +
    `<FL val="Lead Source">Web Download</FL>` +
    `<FL val="First Name">${name}</FL>` +
    `<FL val="Last Name">${name}</FL>` +
    `<FL val="Email">${email}</FL>` +
    `<FL val="Phone">${phone}</FL>` +
    `</row></Leads>`
}



// WEBPACK FOOTER //
// ./src/utils/utils.js